import React from 'react'
import { Heading } from 'components/Heading'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import SoSpecialWrapper from './so-special-style'

import { Button2 as Button } from 'components/Button'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'components/Image'
import { CallToAction } from 'components/CallToAction'

export function NewsSlider({ allNewsSlider, googleImages }) {
    const { title, img, subtitle, video, icon, style = '', enable } = allNewsSlider
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const data = useStaticQuery(
        graphql`
            query newsList {
                allMdx(
                    filter: { fields: { slug: { regex: "/^/news/" } }, frontmatter: { published: { eq: true } } }
                    sort: { fields: [frontmatter___date], order: DESC }
                    limit: 8
                ) {
                    nodes {
                        id
                        frontmatter {
                            title
                            eurl
                        }
                        fields {
                            slug
                        }
                        parent {
                            ... on GoogleDocs {
                                thumbnail: cover {
                                    image {
                                        publicURL
                                        extension
                                        childImageSharp {
                                            gatsbyImageData(layout: FULL_WIDTH)
                                        }
                                    }
                                }
                                darkthumbnail: footer {
                                    image {
                                        extension
                                        publicURL
                                        childImageSharp {
                                            gatsbyImageData(layout: FULL_WIDTH)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    )
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2.5,
        swipeToSlide: true,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.2,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 400,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    const { isDark } = false

    return (
        <SoSpecialWrapper>
            <div className="so-special-head">
                <h3 className="mt-4 text-center text-lg text-red md:mt-8 md:px-8 md:text-2xl">
                    {subtitle}
                    <br />
                </h3>
                <Heading
                    size="md"
                    tag="h1 "
                    className="max-w-[764px] text-center leading-tight sm:text-3xl"
                    theme="white"
                >
                    {title}
                </Heading>
            </div>
            <div className="special_carousel">
                <Slider {...settings}>
                    {data.allMdx.nodes.map(({ id, frontmatter, fields, parent }) => (
                        <CallToAction className="special-cont_btn" type="primary" to={fields.slug} key={id}>
                            <div id="special-cont">
                                <div id="special-cont_img">
                                    <Image
                                        {...(isDark && parent.darkthumbnail.publicURL !== parent.thumbnail.publicURL
                                            ? parent.darkthumbnail
                                            : parent.thumbnail)}
                                        imgStyle={{ objectFit: 'contain' }}
                                        alt={frontmatter.title}
                                    />
                                </div>
                                <div id="special-cont_content">
                                    <p className="special-cont_para">{frontmatter.title}</p>
                                </div>
                            </div>
                        </CallToAction>
                    ))}
                </Slider>
            </div>
            <div className="so-special-foot">
                <p>
                    iCloudReady provides real estate management cloud for leasing and <br></br>
                    selling alike.
                </p>
                <CallToAction type="primary" to="/products">
                    Our Products
                </CallToAction>
            </div>
        </SoSpecialWrapper>
    )
}

export default NewsSlider
